import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import ArticleComponent from '../../components/Article';

export default function OurBlog() {
  return (
    <>
      <Navbar />
      <ArticleComponent />
      <Footer />
    </>
  );
}
